import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the ReservationsAnulatedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reservations-anulated',
  templateUrl: 'reservations-anulated.html',
})
export class ReservationsAnulatedPage {

  public chartData: any;
  public chartLabels: any;
  public chartCheck: any;
  result: any;
  result_total_reservations: any;
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'date_hour', name: this.translate.instant('general-fecha') },
    { prop: 'name', name: this.translate.instant('general-nombre') },
    { prop: 'persons', name: this.translate.instant('general-personas') },
    { prop: 'reason', name: this.translate.instant('general-motivo') },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController
  ) {
    this.getAnalyticsData();
  }

  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'analytics/reservations_anulated', params, {})
      .subscribe(async response => {
        //total
        this.result = response['total_anulated'];
        this.result_total_reservations = response['total_reservations'];

        var rs_foodcost_pb1 = document.getElementById('rs_foodcost_pb1');
        var anulated_percentage = Math.round((this.result / this.result_total_reservations) * 100);
        var reservations_percentage = 100 - Math.round((this.result / this.result_total_reservations) * 100);
        if (rs_foodcost_pb1) {
          rs_foodcost_pb1.style.display = 'none';
          var rs_foodcost_pb1_1 = document.getElementById('rs_foodcost_pb1_1');
          var rs_foodcost_pb1_2 = document.getElementById('rs_foodcost_pb1_2');
          if (rs_foodcost_pb1_1 && rs_foodcost_pb1_2) {
            rs_foodcost_pb1_1.style.width = anulated_percentage + '%';
            rs_foodcost_pb1_2.style.width = reservations_percentage + '%';

            (document.getElementById('rs_foodcost_pb1_1') as HTMLInputElement).innerText = 'D ' + (anulated_percentage || 0) + '%';
            (document.getElementById('rs_foodcost_pb1_2') as HTMLInputElement).innerText = 'A ' + (reservations_percentage || 0) + '%';

            rs_foodcost_pb1.style.display = 'flex';
          }
        }

        //list
        this.rows = response['list'];
        this.temp = response['list'];
        //
        this.chartCheck = true;//boolean check
      });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.date_hour.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const formatedData = this.rows.map(x => ({
      'date': x.date_hour,
      'name': x.name,
      'persons': x.persons,
      'reason': x.reason || ''
    }));
    const params = new HttpParams()
      .set('data', JSON.stringify(formatedData))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({ 'Total anulated': this.result }));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/reservations-anulated/reservations-anulated.ts